export enum IndexType {
  Boolean,
  Double,
  Integer,
  Long,
  LadderTracking,
  PercAway,
  String,
  NaturalString,
  StrikethroughRate,
  FixingDate,
  AgGridDefault,
  Instrument,
  None,
}
